import type { InferGetStaticPropsType } from 'next';
import type { ArtistPagePublishedProps } from '@/shared/fetchStaticData';
import { fetchArtistPageStaticData } from '@/shared/fetchStaticData';
import { ArtistPageLayout } from '@/components/Layout';
import { PressItems } from '@imus/artist-page-template';
import { ComingSoon } from '@/components/ComingSoon';

const PressPage = ({ data, fileBaseUrl, slug }: ArtistPagePublishedProps) => {
  return (
    <ArtistPageLayout fileBaseUrl={fileBaseUrl} data={data} pageId={slug}>
      <PressItems
        contacts={data.press.contacts}
        quotes={data.press.quotes}
        files={data.press.pressFiles}
      />
    </ArtistPageLayout>
  );
};

export default function Page({
  data,
  ...props
}: InferGetStaticPropsType<typeof getStaticProps>) {
  // _props: InferGetStaticPropsType<typeof getStaticProps>
  if (data.published) {
    return <PressPage data={data} {...props} />;
  }
  return <ComingSoon data={data} />;
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export const getStaticProps = fetchArtistPageStaticData;
